/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { ModelUtils } from '../util/ModelUtils';
import { Document } from '../../core/models/Document';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30ResponseDefinition } from '../../openapi/v3/models/Oas30ResponseDefinition';
import { DeleteResponseDefinitionCommand } from './DeleteResponseDefinitionCommand';

/**
 * @author eric.wittmann@gmail.com
 * @extends DeleteResponseDefinitionCommand
 * @class
 */
export class DeleteResponseDefinitionCommand_30 extends DeleteResponseDefinitionCommand {
    public constructor(definitionName? : any) {
        if(((typeof definitionName === 'string') || definitionName === null)) {
            let __args = arguments;
            super(definitionName);
        } else if(definitionName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteResponseDefinitionCommand#doDeleteResponseDefinition(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     * @return {*}
     */
    doDeleteResponseDefinition(document : Document) : any {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(ModelUtils.isDefined(doc30.components) && ModelUtils.isDefined(doc30.components.getResponseDefinition(this._definitionName))) {
            let oldDef : Oas30ResponseDefinition = doc30.components.removeResponseDefinition(this._definitionName);
            return Library.writeNode(oldDef);
        }
        return null;
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteResponseDefinitionCommand#doRestoreResponseDefinition(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} document
     * @param {*} oldDefinition
     */
    doRestoreResponseDefinition(document : Document, oldDefinition : any) {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(ModelUtils.isDefined(doc30.components)) {
            let schemaDef : Oas30ResponseDefinition = doc30.components.createResponseDefinition(this._definitionName);
            Library.readNode(oldDefinition, schemaDef);
            doc30.components.addResponseDefinition(this._definitionName, schemaDef);
        }
    }
}
DeleteResponseDefinitionCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteResponseDefinitionCommand_30";
DeleteResponseDefinitionCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




